import React from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Grid } from '@material-ui/core';

import { MENU_MESA_ENTRADA } from '../../utils/constants';
import { MesaEntradaBreadcrumb } from './UI/MesaEntradaBreadcrumb';
import { MesaEntradaRecepcion } from './MesaEntradaRecepcion/MesaEntradaRecepcion';
import {
  getProcedencia,
  getTipoComprobante,
  getTipoFactura,
  setActiveBreadcrumbMesaEntrada,
} from '../../actions/mesaEntrada/mesaEntradaActions';
import { fetchTipoEfectores } from '../../actions/tipoSubtipoEfectores';
import { GestionComprobantes } from './MesaEntradaGestion/GestionComprobantes';
import { useState } from 'react';
import { TraerEstadosSolicitud } from '../../actions/compras/Cotizaciones';
import { getUsuarioAreaFisicaAction } from '../../actions/usuarios/areasFisicas';
import { useMesaEntrada } from '../../hooks/useCases/useMesaEntrada';
import { GestionOspeDirecto } from './MesaEntradaGestion/GestionOspeDirecto';
import { BuscadorExpedientes } from './BuscadorExpedientes/BuscadorExpedientes';

const style = {
  root: {
    flexGrow: 1,
  },
};

export const MesaEntradaHome = (props) => {
  const dispatch = useDispatch();
  const mesa = useMesaEntrada();

  const [comprobantes, setComprobantes] = useState([]);
  const [contrato, setContrato] = useState(null);
  const { idUsuario } = useSelector((state) => state.auth);

  const { permisos: permisosUser } = useSelector((state) => state.auth);
  const { activeBreadcrumb } = useSelector((state) => state.mesaEntrada);

  const resetRouteStateAndSetActiveBreacDrumb = (item) => {
    props.location.state = { from: props.location.pathname };
    dispatch(setActiveBreadcrumbMesaEntrada(item));
  };

  useEffect(() => {
    dispatch(setActiveBreadcrumbMesaEntrada(MENU_MESA_ENTRADA.DESELECCIONAR));
    dispatch(fetchTipoEfectores());
  }, [dispatch]);

  const { tipoComprobante, tipoFactura, procedencia } = useSelector(
    (state) => state.mesaEntrada,
  );
  const { estados } = useSelector((state) => state.compras);

  useEffect(
    () => tipoComprobante.length === 0 && dispatch(getTipoComprobante()),
    [],
  );
  useEffect(() => tipoFactura.length === 0 && dispatch(getTipoFactura()), []);
  useEffect(() => procedencia.length === 0 && dispatch(getProcedencia()), []);
  useEffect(() => estados === null && dispatch(TraerEstadosSolicitud()), []);
  useEffect(
    () => idUsuario && dispatch(getUsuarioAreaFisicaAction(idUsuario)),
    [],
  );
  useEffect(() => {
    mesa.get.tramites();
    mesa.get.destinos();
  }, []);

  return (
    <div className={style.root}>
      <Grid
        container
        spacing={1}
        direction="row"
        justify="center"
        alignItems="center"
      >
        <Grid item xs={12} styles={{ padding: 5 }}>
          <MesaEntradaBreadcrumb
            activeBreadcrumb={activeBreadcrumb}
            setActiveBreadcrumb={resetRouteStateAndSetActiveBreacDrumb}
            permisos={permisosUser}
            setComprobantes={setComprobantes}
            setContrato={setContrato}
          />
        </Grid>
        {activeBreadcrumb === MENU_MESA_ENTRADA.RECEPCION_COMPROBANTES && (
          <MesaEntradaRecepcion />
        )}
        {(activeBreadcrumb ===
          MENU_MESA_ENTRADA.GESTION_COMPROBANTES_DOCUMENTO ||
          activeBreadcrumb ===
          MENU_MESA_ENTRADA.GESTION_COMPROBANTES_PRESTADORES) && (
            <GestionComprobantes
              setComprobantes={setComprobantes}
              comprobantes={comprobantes}
              contrato={contrato}
              setContrato={setContrato}
            />
          )}
        {activeBreadcrumb === MENU_MESA_ENTRADA.GESTION_COMPROBANTES_OSPE_DIRECTO && (
          <GestionOspeDirecto
            setComprobantes={setComprobantes}
            comprobantes={comprobantes}
          />
        )}
        {activeBreadcrumb === MENU_MESA_ENTRADA.BUSCADOR_EXPEDIENTES && (
          <BuscadorExpedientes
            setComprobantes={setComprobantes}
            comprobantes={comprobantes}
          />
        )}
      </Grid>
    </div>
  );
};
